/* Shelters & Canopies product page: step configurator (live price, conditional steps, multi-line add to basket),
   live front-preview drawing, media tabs, other sizes + bike planner, quote spec. */
(function () {
  'use strict';
  var root = document.querySelector('[data-scp]');
  if (!root || root.__on) return;
  root.__on = true;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var D = root.dataset, BIKES = +D.bikes || 0;
  var gbp = function (p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var gbp0 = function (n) { return '£' + Math.round(n).toLocaleString('en-GB'); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  var qtyEl = $('[data-sc-qty]');

  /* qty stepper (works with and without the configurator) */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]');
    if (b && qtyEl) { qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) + +b.getAttribute('data-q')); qtyEl.dispatchEvent(new Event('input', { bubbles: true })); }
  });

  /* media tabs + thumbs */
  function tab(name) {
    $$('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== name; });
    $$('[data-tab]').forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-tab') === name); });
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tab]'); if (t) tab(t.getAttribute('data-tab'));
    var th = e.target.closest('[data-thumb]');
    if (th) {
      var img = $('[data-photo] img');
      if (img) { img.removeAttribute('srcset'); img.src = th.getAttribute('data-thumb'); }
      $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', x === th); });
    }
  });

  var cfgEl = $('[data-sc-config]'), config = null;
  try { config = cfgEl ? JSON.parse(cfgEl.textContent) : null; } catch (e) { config = null; }

  var sel = {}, opts = config && config.options ? config.options : [];
  var basePrice = parseInt(D.basePrice, 10) || 0;
  var byId = {}; opts.forEach(function (o) { byId[o.id] = o; });
  var sharers = {}; opts.forEach(function (o) { if (o.show_when) sharers[o.show_when.option_id] = (sharers[o.show_when.option_id] || 0) + 1; });
  var group = function (id) { return $('[data-sc-group="' + id + '"]'); };
  var visible = function (o) {
    if (!o.show_when) return true;
    var c = sel[o.show_when.option_id];
    return !!c && (o.show_when.values || []).indexOf(c.label) > -1;
  };
  var offCard = function (o) { return o.show_when && sharers[o.show_when.option_id] === 1; };
  var find = function (o, label) { for (var i = 0; i < o.choices.length; i++) if (o.choices[i].label === label) return o.choices[i]; return null; };
  var CHECK = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 6.5l2.5 2.5L10 3"/></svg>';

  function choose(o, label) {
    var c = label ? find(o, label) : null;
    if (c) sel[o.id] = { label: c.label, price: Math.round((c.price_add || 0) * 100), v: c.addon_variant_id || null, color: c.color || '' };
    else delete sel[o.id];
  }
  function clearGroup(o) {
    var g = group(o.id); if (!g) return;
    $$('input:checked', g).forEach(function (i) { i.checked = false; });
    $$('select', g).forEach(function (s) { s.value = ''; });
  }
  function open(id, on) {
    var g = group(id); if (!g) return;
    var body = $('[data-body]', g), btn = $('[data-toggle]', g);
    body.hidden = !on; btn.setAttribute('aria-expanded', on); g.classList.toggle('is-open', on);
    if (on) $$('img[loading="lazy"]', body).forEach(function (i) { i.loading = 'eager'; });
    pmLabel(g);
  }
  function pmLabel(g) {
    var pm = $('.scp-pm', g); if (!pm) return;
    pm.textContent = g.classList.contains('is-open') ? 'Hide' : g.classList.contains('is-set') ? 'Change' : 'Choose';
  }
  function missing() { return opts.filter(function (o) { return o.required && visible(o) && !sel[o.id]; }); }

  function sync() {
    var n = 0;
    opts.forEach(function (o) {
      var g = group(o.id); if (!g) return;
      var vis = visible(o), off = !vis && offCard(o);
      if (!vis && sel[o.id]) { delete sel[o.id]; clearGroup(o); }
      g.hidden = !vis && !off;
      g.classList.toggle('is-off', off);
      $('[data-toggle]', g).disabled = off;
      if (off) open(o.id, false);
      if (g.hidden) return;
      n++;
      var s = sel[o.id], num = $('[data-num]', g), sum = $('[data-sum]', g);
      g.classList.toggle('is-set', !!s);
      pmLabel(g);
      num.innerHTML = s ? CHECK : (n < 10 ? '0' : '') + n;
      if (off) {
        var p = sel[o.show_when.option_id];
        sum.textContent = p ? 'Not needed with ' + p.label : 'Choose ' + byId[o.show_when.option_id].name.toLowerCase() + ' first';
      } else sum.textContent = s ? s.label + (s.price > 0 ? ' · + ' + gbp(s.price) : ' · Included') : 'Not chosen yet';
    });
  }

  function render() {
    if (!config) return;
    sync();
    var total = basePrice, rows = [[D.baseLabel || 'Base specification', BIKES ? BIKES + ' bikes' : 'Included']], done = 0, count = 0, specTxt = [], specIn = [];
    opts.forEach(function (o) {
      if (!visible(o)) return;
      count++;
      var s = sel[o.id];
      if (s) { done++; total += s.price; specTxt.push(s.label); specIn.push(o.name + ': ' + s.label); }
      rows.push([o.name, s ? s.label : 'Choose a selection']);
    });
    $('[data-total]').textContent = gbp(total);
    var pr = $('[data-prog]'); if (pr) { pr.textContent = done + ' of ' + count + ' options set'; $('[data-progbar]').style.width = (count ? done / count * 100 : 100) + '%'; }
    $('[data-sc-lines]').innerHTML = rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
    var miss = missing(), btn = $('[data-sc-submit]');
    if (!btn.disabled || btn.dataset.busy !== '1') {
      btn.classList.toggle('is-wait', miss.length > 0);
      btn.textContent = miss.length ? 'Choose ' + miss[0].name.toLowerCase() + ' to continue' : btn.dataset.label;
    }
    var q = Math.max(1, parseInt(qtyEl.value, 10) || 1);
    var qs = $('[data-qspec]'), qi = $('[data-qspec-in]');
    if (qs) { qs.hidden = false; qs.textContent = 'Your current specification is attached: ' + (specTxt.length ? specTxt.join(', ') : 'base specification') + ' · qty ' + q; }
    if (qi) qi.value = specIn.concat(['Qty: ' + q, 'Price as configured: ' + gbp(total) + ' each']).join('; ');
    draw(); endFrame();
  }

  if (config) {
    var btn0 = $('[data-sc-submit]'); btn0.dataset.label = btn0.textContent;
    function openNext(from) {
      var start = from ? opts.indexOf(byId[from]) + 1 : 0;
      for (var i = start; i < opts.length; i++) { var o = opts[i]; if (visible(o) && !sel[o.id]) { open(o.id, true); return; } }
    }
    root.addEventListener('change', function (e) {
      var f = e.target, o = f.name && byId[f.name];
      if (!o) return;
      choose(o, f.value);
      render();
      msg('');
      if (f.type === 'radio' || f.tagName === 'SELECT') {
        var g = group(o.id), k = g.getAttribute('data-kind');
        if (k !== 'swatch' || sel[o.id]) { setTimeout(function () { open(o.id, false); openNext(o.id); }, k === 'tiles' || k === 'swatch' ? 250 : 120); }
      }
      if (o.id === 'frame_end_design' && $('[data-tab="end"]') && !$('[data-tab="end"]').hidden) tab('end');
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-toggle]');
      if (t) { var g = t.closest('[data-sc-group]'); open(g.getAttribute('data-sc-group'), t.getAttribute('aria-expanded') !== 'true'); }
      var sa = e.target.closest('[data-showall]');
      if (sa) { $$('[data-more]', sa.parentNode).forEach(function (x) { x.hidden = false; var im = $('img', x); if (im) im.loading = 'eager'; }); sa.remove(); }
      if (e.target.closest('[data-reset]')) { sel = {}; opts.forEach(clearGroup); render(); opts.forEach(function (o) { open(o.id, false); }); openNext(); }
    });
    qtyEl.addEventListener('input', render);

    var msgEl = $('[data-sc-message]');
    function msg(t) { msgEl.textContent = t; msgEl.hidden = !t; }

    $('[data-sc-submit]').addEventListener('click', function () {
      var btn = this, miss = missing();
      msg('');
      if (miss.length) {
        var g = group(miss[0].id); open(miss[0].id, true);
        if (g) g.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
      var cid = 'sc-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var props = { _config_id: cid }, addons = [], broken = [];
      opts.forEach(function (o) {
        if (!visible(o) || !sel[o.id]) return;
        var s = sel[o.id];
        props[o.name] = s.label;
        if (s.price > 0) {
          if (!s.v) { broken.push(o.name); return; }
          addons.push({ id: s.v, quantity: qty, properties: { _config_id: cid, _addon_for: o.name } });
        }
      });
      if (broken.length) { msg('Pricing is not linked for: ' + broken.join(', ') + '. Please contact us to order this combination.'); return; }
      btn.disabled = true; btn.dataset.busy = '1'; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: D.baseVariant, quantity: qty, properties: props }].concat(addons) })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) { if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to basket.'); window.location.href = '/cart'; })
        .catch(function (err) { msg(err.message); btn.disabled = false; btn.dataset.busy = ''; btn.textContent = btn.dataset.label; });
    });

    /* info modal */
    var modal = $('[data-sc-modal]');
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sc-info]');
      if (t) { $('[data-sc-modal-title]', modal).textContent = t.closest('[data-sc-group]').querySelector('.scp-st b').textContent; $('[data-sc-modal-body]', modal).textContent = t.getAttribute('data-sc-info'); modal.hidden = false; $('[data-sc-modal-close]', modal).focus(); return; }
      if (e.target === modal || e.target.closest('[data-sc-modal-close]')) modal.hidden = true;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') modal.hidden = true; });

    render();
    openNext();
  }

  /* end-frame tab: shows the chosen frame design image when the store has one */
  function endFrame() {
    var t = $('[data-tab="end"]'), box = $('[data-end]'); if (!t || !box) return;
    var g = group('frame_end_design'), s = sel.frame_end_design, lab = null;
    if (g && s) $$('label[data-img]', g).forEach(function (l) { if ($('input', l).value === s.label) lab = l; });
    t.hidden = !lab;
    if (lab) box.innerHTML = '<img src="' + lab.getAttribute('data-img') + '" alt="' + esc(s.label) + '"><p>' + esc(s.label) + '</p>';
    else if (!$('[data-pane="end"]').hidden) tab($('[data-tab="prev"]') ? 'prev' : 'photos');
  }

  /* live front-preview drawing */
  function bike(x, y, c) {
    return '<g transform="translate(' + x + ',' + y + ')" fill="none" stroke="' + c + '" stroke-width="2.4" stroke-linecap="round"><circle cx="-15" cy="0" r="13"/><circle cx="15" cy="0" r="13"/><path d="M-15 0l9-16h14l7 16M-6-16l-3-6M8-16l3 16M8-16l2-6h5"/></g>';
  }
  function draw() {
    var box = $('[data-prev]'); if (!box) return;
    var fin = sel.finish ? sel.finish.label.toLowerCase() : '', col = sel.powder_coat_colour;
    var frame = col && /powder/.test(fin) ? col.color || '#8B949A' : '#8B949A';
    var sheet = 'rgba(176,205,222,.55)', W = 560, G = 268, roof = D.roof, lay = D.layout;
    var ep = null; Object.keys(sel).forEach(function (k) { if (/end_panel/.test(k) && !/^no/i.test(sel[k].label)) ep = sel[k].label; });
    var cloak = sel.cloaking_set && !/^no/i.test(sel.cloaking_set.label);
    var gate = null; Object.keys(sel).forEach(function (k) { if (/gate/.test(k) && !/lock/.test(k) && !/^no/i.test(sel[k].label)) gate = sel[k].label; });
    var h = '<svg viewBox="0 0 ' + W + ' 300" role="img" aria-label="Front view illustration of the shelter as configured">';
    var top = roof === 'flat' ? [62, 86] : [70, 70], posts = [36, 280, 524];
    if (lay === 'compound' || lay === 'twotier' || ep) {
      var th = /themed/i.test(ep || '') ? '<pattern id="scpt" width="14" height="14" patternUnits="userSpaceOnUse"><circle cx="7" cy="7" r="3" fill="' + frame + '" opacity=".5"/></pattern>' : '';
      if (th) h += '<defs>' + th + '</defs>';
      [[22, 30], [508, 30]].forEach(function (p, i) { h += '<rect x="' + p[0] + '" y="' + (i ? top[1] : top[0]) + '" width="30" height="' + (G - (i ? top[1] : top[0])) + '" fill="' + (th ? 'url(#scpt)' : sheet) + '" stroke="' + frame + '" stroke-width="1.5"/>'; });
    }
    if (lay === 'compound' || gate) {
      h += '<g stroke="' + frame + '" stroke-width="1" opacity=".55">';
      for (var gx = 60; gx < 500; gx += 14) h += '<path d="M' + gx + ' ' + (G - 120) + 'V' + G + '"/>';
      h += '<path d="M52 ' + (G - 120) + 'H508" stroke-width="3"/></g>';
    }
    posts.forEach(function (x, i) {
      if (roof === 'cantilever' && i !== 1) return;
      var y = roof === 'flat' ? top[0] + (top[1] - top[0]) * (x / W) : top[0] - (i === 1 ? 26 : 0);
      h += '<rect x="' + (x - 5) + '" y="' + (y + 4) + '" width="10" height="' + (G - y - 4) + '" fill="' + frame + '"/><rect x="' + (x - 11) + '" y="' + (G - 3) + '" width="22" height="5" fill="' + frame + '"/>';
    });
    var rp = roof === 'flat' ? 'M14 ' + top[0] + 'L546 ' + top[1] : 'M14 ' + top[0] + 'Q280 ' + (top[0] - 52) + ' 546 ' + top[1];
    h += '<path d="' + rp + '" fill="none" stroke="' + sheet.replace('.55', '.95') + '" stroke-width="16"' + (roof === 'vented' ? ' stroke-dasharray="120 10"' : '') + '/>';
    h += '<path d="' + rp + '" fill="none" stroke="' + frame + '" stroke-width="' + (cloak ? 6 : 3) + '" transform="translate(0,' + (cloak ? 9 : 8) + ')"/>';
    var n = Math.min(BIKES, lay === 'twotier' ? 3 : 4), y1 = G - 14, step = n ? 420 / n : 0;
    for (var i = 0; i < n; i++) {
      h += bike(92 + step * i + step / 2 - 20, y1, '#111418');
      if (lay === 'twotier') h += bike(92 + step * i + step / 2 - 20, y1 - 92, '#111418');
    }
    if (lay === 'twotier') h += '<path d="M60 ' + (y1 - 74) + 'H500" stroke="' + frame + '" stroke-width="4"/>';
    h += '<path d="M0 ' + (G + 2) + 'H' + W + '" stroke="#111418" stroke-width="2"/></svg>';
    box.innerHTML = h;
  }
  if (!config) draw();

  /* other sizes in the same range + bike planner */
  var sizes = $('[data-sizes]'), sibs = [];
  function plan() {
    var needEl = $('[data-need]'); if (!needEl) return;
    var need = Math.max(1, +needEl.textContent || 1), units = Math.ceil(need / BIKES), tot = units * BIKES, spare = tot - need;
    var alt = sibs.filter(function (x) { return x.b >= need && x.h !== D.handle; }).sort(function (a, b) { return a.b - b.b; })[0];
    $('[data-plan]').innerHTML = '<b>' + units + ' × this ' + D.noun + ' = ' + tot + ' spaces</b><small>' + (spare ? spare + ' spare for growth · ' : 'An exact fit · ') + '<button type="button" data-setq="' + units + '">set qty to ' + units + ' above</button></small>' +
      (alt && units > 1 ? '<small>Or one <a href="/products/' + alt.h + '">' + alt.b + '-bike ' + D.noun + '</a> from ' + gbp0(alt.p) + '</small>' : '');
  }
  if (sizes && BIKES && D.dept) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pn]');
      if (b) { var el = $('[data-need]'); el.textContent = Math.max(1, (+el.textContent || 1) + +b.getAttribute('data-pn')); plan(); }
      var sq = e.target.closest('[data-setq]');
      if (sq && qtyEl) { qtyEl.value = sq.getAttribute('data-setq'); qtyEl.dispatchEvent(new Event('input', { bubbles: true })); qtyEl.closest('.scp-spec, form').scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    });
    sizes.hidden = false; plan();
    var all = [];
    (function load(n) {
      return fetch('/collections/' + D.dept + '/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (j) {
        var ps = j.products || []; all = all.concat(ps);
        return ps.length === 250 && n < 4 ? load(n + 1) : all;
      });
    })(1).then(function (ps) {
      var by = {};
      ps.forEach(function (p) {
        if (p.product_type !== D.type || /add-?on/i.test(p.product_type)) return;
        var m = p.title.match(/(\d{1,3})\s*[- ]?\s*(?:bike|cycle|bicycle|space)s?\b/i) || p.title.match(/for\s+(\d{1,3})\s+(?:bikes|cycles)/i);
        if (!m) return;
        var pr = Infinity; (p.variants || []).forEach(function (v) { var x = parseFloat(v.price); if (x > 0 && x < pr) pr = x; });
        var o = { b: +m[1], h: p.handle, t: p.title, p: pr };
        if (p.handle === D.handle) o.cur = true;
        if (!by[o.b] || o.cur || (!by[o.b].cur && o.p < by[o.b].p)) by[o.b] = o;
      });
      sibs = Object.keys(by).map(function (k) { return by[k]; }).sort(function (a, b) { return a.b - b.b; });
      plan();
      if (sibs.length < 2) { $('[data-ladder]').parentNode.hidden = true; return; }
      var RL = { curved: 'curved roof', cantilever: 'cantilever', vented: 'vented roof', flat: 'monopitch roof' };
      $('[data-sizes-ey]').textContent = RL[D.roof] ? 'Same ' + RL[D.roof] + ', other sizes' : 'Same range, other sizes';
      $('[data-ladder]').innerHTML = sibs.map(function (x) {
        return x.cur ? '<div class="scp-sz is-cur"><b>' + x.b + '</b><small>BIKES</small><span>You are viewing this ' + D.noun + '</span><em>Configuring now</em></div>'
          : '<a class="scp-sz" href="/products/' + x.h + '"><b>' + x.b + '</b><small>BIKES</small><span>' + esc(x.t) + '</span><em>from ' + gbp0(x.p) + '</em></a>';
      }).join('');
    }).catch(function () {});
  }
})();
